import PropTypes from "prop-types"
import genericFilterGroup from "shared/search/containers/FilterGroup/FilterGroups.js"
import {
    AddedIdsFilter,
    DateListNoFutureFilter,
    DeletedIdsFilter,
    OnlyIdsFilter,
    PriorityLastUserFilter,
    StanceFilter,
    StanceLastUserFilter,
} from "shared/search/containers/Filter/Filters"
import { inIssueFilter, notInIssueFilter } from "shared/search/containers/Filter/FilterCreators"

import {
    AlertDataTypeFilter,
    AlertFrequencyFilter,
    AlertGroupTitleFilter,
    AlertTitleFilter,
    AlertUpdateTypeFilter,
    FeedItemAdminFilter,
    FeedItemAlertFilter,
    FeedItemAlertGroupFilter,
    FeedItemAmendmentFilter,
    FeedItemArticleFilter,
    FeedItemAssignmentFilter,
    FeedItemBillFilter,
    FeedItemContactFilter,
    FeedItemCreatorFilter,
    FeedItemDatePickerStartNoFutureFilter,
    FeedItemDatePickerEndNoFutureFilter,
    FeedItemDeliveryMediumFilter,
    FeedItemDescriptionFilter,
    FeedItemDocumentFilter,
    FeedItemEventFilter,
    FeedItemInvisibleDeliverablesFilter,
    FeedItemIsDefaultFilter,
    FeedItemNoteFilter,
    FeedItemOfficialFilter,
    FeedItemOfficialsAndStaffFilter,
    FeedItemOwnerFilter,
    FeedItemPriorityFilter,
    FeedItemRegulationFilter,
    FeedItemStafferFilter,
    FeedItemVoteFilter,
} from "shared/search/containers/Filter/FeedItemFilters"

// types
const defaultPropTypes = {
    displayLabel: PropTypes.string,
    filters: PropTypes.arrayOf(PropTypes.func),
    helpText: PropTypes.string,
    uniqueFilterGroupId: PropTypes.string,
}

// filter groups
export const FeedItemCreatorFilterGroup = (props) => genericFilterGroup(props)
FeedItemCreatorFilterGroup.propTypes = defaultPropTypes
FeedItemCreatorFilterGroup.defaultProps = {
    filters: [FeedItemCreatorFilter, ...(Userdata.is_admin ? [FeedItemOwnerFilter] : []), FeedItemIsDefaultFilter],
    uniqueFilterGroupId: "feedItemCreatorFilterGroup",
    displayLabel: Userdata.is_admin ? "Creator/Owner" : "Creator",
    helpText: "Filter by creator",
}

export const FeedItemAlertFilterGroup = (props) => genericFilterGroup(props)
FeedItemAlertFilterGroup.propTypes = defaultPropTypes
FeedItemAlertFilterGroup.defaultProps = {
    filters: [FeedItemAlertFilter, FeedItemAlertGroupFilter],
    uniqueFilterGroupId: "feedItemAlertFilterGroup",
    displayLabel: "Alerts",
    helpText: "Filter by the parent Alert or Alert Group that the Alert item is associated with.",
}

export const FeedItemDatasetFilterGroup = (props) => genericFilterGroup(props)
FeedItemDatasetFilterGroup.propTypes = defaultPropTypes
FeedItemDatasetFilterGroup.defaultProps = {
    filters: [
        FeedItemAssignmentFilter,
        FeedItemAmendmentFilter,
        FeedItemBillFilter,
        FeedItemContactFilter,
        FeedItemDocumentFilter,
        FeedItemEventFilter,
        FeedItemArticleFilter,
        FeedItemNoteFilter,
        FeedItemOfficialsAndStaffFilter,
        FeedItemOfficialFilter,
        FeedItemRegulationFilter,
        FeedItemStafferFilter,
        FeedItemVoteFilter,
    ],
    uniqueFilterGroupId: "feedItemDatasetFilterGroup",
    displayLabel: "Referencing",
    helpText: "Filter by the data point that the Alert item is referencing.",
}

export const FeedItemDataTypeFilterGroup = (props) => genericFilterGroup(props)
FeedItemDataTypeFilterGroup.propTypes = defaultPropTypes
FeedItemDataTypeFilterGroup.defaultProps = {
    filters: [AlertDataTypeFilter],
    uniqueFilterGroupId: "feedItemDataTypeFilterGroup",
    displayLabel: "Data Type",
    helpText: "Filter by alert data type",
}

export const FeedItemDateFilterGroup = (props) => genericFilterGroup(props)
FeedItemDateFilterGroup.propTypes = defaultPropTypes
FeedItemDateFilterGroup.defaultProps = {
    filters: [DateListNoFutureFilter, FeedItemDatePickerStartNoFutureFilter, FeedItemDatePickerEndNoFutureFilter],
    uniqueFilterGroupId: "feedItemDateFilterGroup",
    displayLabel: "Date Alert Received",
    helpText: "Filter for results that took place after a particular date " + "or within a specific date range.",
}

export const FeedItemDeliveryMediumFilterGroup = (props) => genericFilterGroup(props)
FeedItemDeliveryMediumFilterGroup.propTypes = defaultPropTypes
FeedItemDeliveryMediumFilterGroup.defaultProps = {
    filters: [FeedItemDeliveryMediumFilter],
    uniqueFilterGroupId: "feedItemDeliveryMediumFilterGroup",
    displayLabel: "Delivery Medium",
    helpText: "Filter by delivery medium.",
}

export const FeedItemFrequencyFilterGroup = (props) => genericFilterGroup(props)
FeedItemFrequencyFilterGroup.propTypes = defaultPropTypes
FeedItemFrequencyFilterGroup.defaultProps = {
    filters: [AlertFrequencyFilter],
    uniqueFilterGroupId: "feedItemFrequencyFilterGroup",
    displayLabel: "Alert Frequency",
    helpText: "Filter by alert frequency type.",
}

export const FeedItemUpdateTypeFilterGroup = (props) => genericFilterGroup(props)
FeedItemUpdateTypeFilterGroup.propTypes = defaultPropTypes
FeedItemUpdateTypeFilterGroup.defaultProps = {
    filters: [AlertUpdateTypeFilter],
    uniqueFilterGroupId: "feedItemUpdateTypeFilterGroup",
    displayLabel: "Update Type",
    helpText: "Filter by alert update type.",
}

export const FeedItemAdminFilterGroup = (props) => genericFilterGroup(props)
FeedItemAdminFilterGroup.propTypes = defaultPropTypes
FeedItemAdminFilterGroup.defaultProps = {
    filters: [FeedItemAdminFilter],
    uniqueFilterGroupId: "feedItemAdminFilterGroup",
    displayLabel: "Admin",
    helpText: "Filter by options that are only available to Administrators.",
}

export const FeedItemStanceFilterGroup = (props) => genericFilterGroup(props)
FeedItemStanceFilterGroup.propTypes = defaultPropTypes
FeedItemStanceFilterGroup.defaultProps = {
    filters: [StanceFilter, StanceLastUserFilter],
    uniqueFilterGroupId: "feedItemStanceFilterGroup",
    displayLabel: "Stance",
    helpText: "Filter Alerts by your organization's stance on the underlying dataset object.",
}

export const FeedItemPriorityFilterGroup = (props) => genericFilterGroup(props)
FeedItemPriorityFilterGroup.propTypes = defaultPropTypes
FeedItemPriorityFilterGroup.defaultProps = {
    filters: [FeedItemPriorityFilter, PriorityLastUserFilter],
    uniqueFilterGroupId: "feedItemPriorityFilterGroup",
    displayLabel: "Priority",
    helpText: "Filter Alerts by your organization's stance on the underlying dataset object.",
}

export const FeedItemIssueFilterGroup = (props) => genericFilterGroup(props)
FeedItemIssueFilterGroup.propTypes = defaultPropTypes
FeedItemIssueFilterGroup.defaultProps = {
    filters: [inIssueFilter, notInIssueFilter],
    uniqueFilterGroupId: "feedItemIssueFilterGroup",
    displayLabel: "Issues",
    helpText: "Filter alerts by the issue they are tagged to.",
}

export const FeedItemInvisibleFilterGroup = (props) => genericFilterGroup(props)
FeedItemInvisibleFilterGroup.defaultProps = {
    filters: [FeedItemInvisibleDeliverablesFilter],
    uniqueFilterGroupId: "feedItemInvisibleFilterGroup",
    invisible: true,
}
